import {
  AssociatedPerson,
  BusinessAddress,
  BusinessRegistration,
} from 'dashboard/models/report/business-lookup';
import { Iso8601DateString } from 'lib/types';

export interface IncorporationDate {
  granularity?: string;
  day?: string;
  month?: string;
  year?: string;
}

export interface IndustryClassification {
  code?: string;
  title?: string;
  type?: string;
}

export enum BusinessIdentifierType {
  Ein = 'ein',
  Lei = 'lei',
  Tin = 'tin',
  VatEu = 'vat_eu',
  Br = 'br',
  BrFrSiren = 'br_fr_siren',
  BrFrSiret = 'br_fr_siret',
  BrMcSiren = 'br_mc_siren',
  BrLiUid = 'br_li_uid',
  BrChUid = 'br_ch_uid',
  BrPlRegon = 'br_pl_regon',
  UsStateRegistrationNumber = 'us_state_registration_number',
}

export interface BusinessIdentifier extends BusinessRegistration {
  country?: string;
  type?: BusinessIdentifierType;
}

export interface BusinessAgent {
  'name-full'?: string;
}

export interface BusinessSource {
  name?: string;
  url?: string;
  'last-updated-at'?: Iso8601DateString;
}

export interface BusinessLookupEdgeResult {
  name?: string;
  aliases?: string[];
  description?: string;
  'match-confidence'?: number;
  'legal-status'?: string;
  'legal-entity-type'?: string;
  'date-of-incorporation'?: IncorporationDate;
  'industry-classifications'?: IndustryClassification[];
  identifiers?: BusinessIdentifier[];
  addresses?: BusinessAddress[];
  websites?: string[];
  'phone-numbers'?: string[];
  agents?: BusinessAgent[];
  officers?: AssociatedPerson[];
  headcount?: string;
  sources?: BusinessSource[];
}
